/* ==============================================
   CAMPY PARALLAX
   Lightweight parallax for Dawn's Image Banner.
   Add this file to Assets and load it in theme.liquid.
   ============================================== */
(function() {
  const banner = document.querySelector('.banner');
  if (!banner) return;

  banner.setAttribute('data-campy-parallax', '');
  const img = banner.querySelector('.banner__media img');
  if (!img) return;

  let ticking = false;

  function updateParallax() {
    const rect = banner.getBoundingClientRect();
    const windowH = window.innerHeight;

    if (rect.bottom < 0 || rect.top > windowH) {
      ticking = false;
      return;
    }

    const progress = (windowH - rect.top) / (windowH + rect.height);
    const offset = (progress - 0.5) * 60;
    img.style.transform = 'translate3d(0,' + offset + 'px,0)';
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }, { passive: true });

  updateParallax();
})();